export enum userDeleteActiontype {
  DELETE_USER = "delete_user",
  DELETE_USER_SUCCESS = "delete_user_success",
  DELETE_USER_FAILURE = "delete_user_failure",
}
